import { elakayAutoText } from '../../pageInside/dataElakay';
import { roleDisplayLabel } from '../../../utils/roleDisplayLabel';

// Display-only vocabulary for the Promotions Wall. The persisted/API role
// remains "Family" so existing tokens, permissions and data keep working.
export const promotionWallDisplayLabel = (role, fallback) => {
  const normalized = String(role || '').replace(/[\s_-]+/g, '').toLowerCase();
  if (['family', 'familly', 'famille'].includes(normalized)) {
    return elakayAutoText('h_promotion_wall_family', 'Developer');
  }
  return roleDisplayLabel(role, fallback);
};

export default promotionWallDisplayLabel;
